import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../components/TextInput/TextInput';
import { useForm } from '../../../utils/customHooks/use-form';
import Checkbox from '../../../components/Checkbox/Checkbox';
import RadioButtonGroup from '../../../components/RadioButtonGroup/RadioButtonGroup';
import SimpleButton from '../../../components/Buttons/SimpleButton/SimpleButton';
import Color from '../../../components/Buttons/Color';
import InfoText from './InfoText';
import NOB from '../../../constants/language-strings';
import { INPUT_TYPES } from '../FollowUpConstans';
import AddFiles from '../../../components/addFiles/addFiles';
function FollowUpForm({ files, form, onSubmit, isSubmitted, saveFiles }) {
    const { values, handleChange, handleSubmit } = useForm(() => {
        onSubmit(values);
    });
    const inputs = form.inputs.map(input => {
        switch (input.type) {
            case INPUT_TYPES.TEXT:
                return (_jsx(TextInput, { onChange: handleChange, label: input.headline, value: values[input.headline] ? values[input.headline] : '', name: input.headline, placeholder: input.placeholder, hasError: isSubmitted && !values[input.headline] }, input.headline));
            case INPUT_TYPES.CHECKBOX: {
                return (_jsx(Checkbox, { onClick: handleChange, name: input.option, label: input.option, checked: values[input.option] }, input.option));
            }
            case INPUT_TYPES.RADIO:
                return (_jsx(RadioButtonGroup, { title: input.title, values: input.options, chosenValue: values[input.title], onChange: handleChange, hasError: isSubmitted && !values[input.title] }, input.title));
            case INPUT_TYPES.INFO_TEXT:
                return _jsx(InfoText, { text: input.headline }, input.headline);
            default:
                return null;
        }
    });
    return (_jsxs("div", { className: "follow-up-form", children: [inputs, _jsx(AddFiles, { saveFiles: saveFiles, files: files, type: "FollowUp" }), _jsx(SimpleButton, { color: Color.BLACK, onClick: handleSubmit, title: NOB.FOLLOW_UP.CREATE_BUTTON })] }));
}
FollowUpForm.propTypes = {
    files: PropTypes.arrayOf(PropTypes.any).isRequired,
    form: PropTypes.objectOf(PropTypes.any).isRequired,
    onSubmit: PropTypes.func.isRequired,
    isSubmitted: PropTypes.bool.isRequired,
    saveFiles: PropTypes.func.isRequired,
};
export default FollowUpForm;
